import { render, staticRenderFns } from "./ProfileTab.vue?vue&type=template&id=f8ea56f8&scoped=true&"
import script from "./ProfileTab.vue?vue&type=script&lang=js&"
export * from "./ProfileTab.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTab.vue?vue&type=style&index=0&id=f8ea56f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ea56f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8ea56f8')) {
      api.createRecord('f8ea56f8', component.options)
    } else {
      api.reload('f8ea56f8', component.options)
    }
    module.hot.accept("./ProfileTab.vue?vue&type=template&id=f8ea56f8&scoped=true&", function () {
      api.rerender('f8ea56f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/form/components/ProfileTab.vue"
export default component.exports